import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface PublicService {
  id: string;
  name: string;
  duration: string;
  price: string;
  category: string | null;
  description: string | null;
  is_quote_only: boolean;
}

/**
 * Active services for an organisation, ordered for public display.
 * Powers the public Services page (Roadmap 1H) so it reflects the tenant's
 * real offering instead of hardcoded marketing copy.
 */
export function useServices(orgId: string | undefined) {
  return useQuery({
    queryKey: ['public-services', orgId],
    enabled: Boolean(orgId),
    queryFn: async (): Promise<PublicService[]> => {
      const { data, error } = await supabase
        .from('services')
        .select('id, name, duration, price, category, description, is_quote_only')
        .eq('organization_id', orgId!)
        .eq('is_active', true)
        .order('sort_order', { ascending: true });

      if (error) throw error;

      return (data ?? []).map((service) => ({
        ...service,
        is_quote_only: service.is_quote_only ?? false,
      }));
    },
  });
}
